export default class LazyLoadElementWrapper {
  constructor(
    private readonly targetElement: HTMLElement
  ) {
    this.isLoaded = false;
  }

  public get isInViewPort(): boolean {
    const { top, bottom } = this.targetElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    const isTopVisible = 0 < top && top < viewportHeight;
    const isBottomVisible = 0 < bottom && bottom < viewportHeight;

    return isTopVisible || isBottomVisible;
  }

  public get canBeLoaded(): boolean {
    return this.isInViewPort && !this.isLoaded;
  }

  public get isLoaded(): boolean {
    return this.targetElement.dataset.isLoaded === '1';
  }

  public set isLoaded(loaded: boolean) {
    this.targetElement.dataset.isLoaded = loaded ? '1' : '0';
  }

  public getElementAs<T extends HTMLElement = HTMLElement>(): T {
    return this.targetElement as T;
  }
}
